<template>
  <span class="mescan-rating" :class="{ 'mescan-rating--full': full, 'mescan-rating--unrated': rating.index === null }" :style="{ '--rating-color': rating.color }" :aria-label="rating.index === null ? 'Keine MeScan-Bewertung vorhanden' : 'MeScan-Bewertung: Stufe ' + (rating.index + 1) + ' von ' + rating.colors.length">
    <span class="mescan-rating__label"><i aria-hidden="true" />{{ rating.label }}</span>
    <span v-if="full && rating.index !== null" class="mescan-rating__scale" aria-hidden="true"><i v-for="(color, position) in rating.colors" :key="position" :class="{ 'is-current': position === rating.index }" :style="{ '--band-color': color }" /></span>
  </span>
</template>
<script>
import { meScanRating } from "@/services/mescanHealthData"
export default {
  props: { metric: { type: String, default: "" }, index: { type: Number, default: null }, full: Boolean },
  computed: { rating() { return meScanRating(this.metric, this.index) } },
}
</script>
<style scoped>
.mescan-rating { display: inline-flex; flex-direction: column; gap: 10px; min-width: 0; font-size: 10px; line-height: 1.4; font-weight: 500; color: #ced1d0; }
.mescan-rating__label { display: inline-flex; align-items: center; gap: 6px; }
.mescan-rating__label > i { display: inline-block; flex-shrink: 0; width: 6px; height: 6px; border-radius: 50%; background: var(--rating-color); }
.mescan-rating--unrated { color: #999fa1; }
.mescan-rating--full { width: 100%; font-size: 12px; }
.mescan-rating__scale { display: flex; align-items: center; gap: 4px; height: 13px; }
.mescan-rating__scale > i { position: relative; flex: 1; height: 5px; border-radius: 5px; background: var(--band-color); opacity: .3; }
.mescan-rating__scale > .is-current { height: 9px; opacity: 1; }
.mescan-rating__scale > .is-current::after { content: ""; position: absolute; left: 50%; top: -6px; width: 3px; height: 3px; background: #fff; border-radius: 50%; transform: translateX(-50%); }
</style>
